import React from 'react';
import './BrandSlider.css';
import star from '../../assets/images/slider/star.png';
import brandLogo1 from '../../assets/svg/regional-hero-logo.svg';
import brandLogo2 from '../../assets/images/gourmet-jobs.png';
import brandLogo3 from '../../assets/images/slider/advance-work.png';
import brandLogo4 from '../../assets/images/slider/smartsy.svg';
import brandLogo5 from '../../assets/images/slider/stupendastic-logo.webp'
import brandLogo6 from '../../assets/images/slider/patrimore-logo.png';


const BrandSlider = () => {
  return (
    <div className="brand__slider">
      <div className="brand__logos">
        <div className="brand__items">
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo1} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img className="brand__logo--gourmet" src={brandLogo2} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo3} alt="" />
          </div>
        </div>

        <div className="brand__items">
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo4} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img className="brand__logo--stupendastic" src={brandLogo5} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo6} alt="" />
          </div>
        </div>

        <div className="brand__items">
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo1} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img className="brand__logo--gourmet" src={brandLogo2} alt="" />
          </div>
          <div className="brand__star">
            <img src={star} alt="" />
          </div>
          <div className="brand__logo">
            <img src={brandLogo3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandSlider;
